import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Alert } from 'react-bootstrap';

const ShopifyInstall = () => {
    const [shopDomain, setShopDomain] = useState('');
    const [isInstalling, setIsInstalling] = useState(false);
    const [error, setError] = useState('');

    // Shopify OAuth configuration
    const SHOPIFY_API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY || 'your-shopify-api-key';
    const REDIRECT_URI = 'https://alani360meli.com/shopify/api/auth';
    const SCOPES = 'read_products,write_products,read_publications,write_publications,write_orders,read_inventory,write_inventory,read_product_listings,read_metaobjects';


    console.log(SHOPIFY_API_KEY);
    console.log(REDIRECT_URI);
    console.log(SCOPES);

    const generateState = () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    };

    const validateShopDomain = (domain) => {
        // Remove any protocol and trailing slashes
        domain = domain.replace(/^https?:\/\//, '').replace(/\/$/, '');

        // Remove .myshopify.com if present
        domain = domain.replace(/\.myshopify\.com$/, '');

        // Check if domain is valid (alphanumeric and hyphens only)
        const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$|^[a-zA-Z0-9]$/; // eslint-disable-line no-useless-escape
        return domainRegex.test(domain) ? domain : null;
    };

    const handleInstallApp = (e) => {
        if (e) e.preventDefault();

        setError('');

        // Validate shop domain
        const cleanDomain = validateShopDomain(shopDomain);
        if (!cleanDomain) {
            setError('Please enter a valid shop name (letters, numbers, and hyphens only)');
            return;
        }

        setIsInstalling(true);

        try {
            // Generate state parameter for CSRF protection
            const state = generateState();

            // Store state in sessionStorage for validation on callback
            sessionStorage.setItem('shopify_oauth_state', state);
            sessionStorage.setItem('shopify_shop_domain', cleanDomain);

            // Construct Shopify OAuth URL
            const shopifyDomain = `${cleanDomain}.myshopify.com`;
            const oauthUrl = new URL(`https://${shopifyDomain}/admin/oauth/authorize`);

            oauthUrl.searchParams.set('client_id', SHOPIFY_API_KEY);
            oauthUrl.searchParams.set('scope', SCOPES);
            oauthUrl.searchParams.set('redirect_uri', REDIRECT_URI);
            oauthUrl.searchParams.set('state', state);
            //oauthUrl.searchParams.set('grant_options[]', 'per-user');
            oauthUrl.searchParams.set('grant_options[]', 'value');  // This requests offline tokens

            // Redirect to Shopify OAuth
            window.location.href = oauthUrl.toString();

        } catch (err) {
            setError('Failed to initiate installation. Please try again.');
            setIsInstalling(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col lg={8}>
                        {/* Header */}
                        <div className="text-center mb-5">
                            <h1 className="display-5 fw-bold text-orange mb-3">
                                <i className="fab fa-shopify me-3"></i>
                                ALANI360 App
                            </h1>
                            <p className="lead text-muted">
                                Connect your Shopify store to ALANI360's powerful e-commerce ecosystem
                            </p>
                            <img width={150} src="/images/logo_large_plus@2x.webp" alt="MercadoLibre" className="img-fluid" />
                            <br />
                            <img width={90} src="/images/by_alani.jpg" alt="by ALANI360" className="img-fluid" />

                        </div>

                        {/* Installation Form */}
                        <Row className="justify-content-center">
                            <Col md={8} lg={6}>
                                <Card className="shadow-lg border-0">
                                    <Card.Header className="bg-success text-white text-center py-4">
                                        <h4 className="mb-0">Connect Your Store</h4>
                                    </Card.Header>
                                    <Card.Body className="p-4">
                                        {error && (
                                            <Alert variant="danger" dismissible onClose={() => setError('')}>
                                                <i className="fas fa-exclamation-triangle me-2"></i>
                                                {error}
                                            </Alert>
                                        )}

                                        <Form onSubmit={handleInstallApp}>
                                            <Form.Group className="mb-4">
                                                <Form.Label className="fw-bold">
                                                    <i className="fas fa-store me-2"></i>
                                                    Shop Domain
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="your-store-name"
                                                    value={shopDomain}
                                                    onChange={(e) => setShopDomain(e.target.value)}
                                                    isInvalid={!!error}
                                                    size="lg"
                                                    className="text-center"
                                                />
                                                <Form.Text className="text-muted">
                                                    <i className="fas fa-info-circle me-1"></i>
                                                    Enter your shop name (without .myshopify.com)
                                                </Form.Text>
                                            </Form.Group>

                                            <div className="d-grid mb-3">
                                                <Button
                                                    type="submit"
                                                    variant="success"
                                                    size="lg"
                                                    disabled={!shopDomain.trim() || isInstalling}
                                                >
                                                    {isInstalling ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                            Connecting to Shopify...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-plug me-2"></i>
                                                            Install ALANI360 App
                                                        </>
                                                    )}
                                                </Button>
                                            </div>

                                            <div className="text-center">
                                                <small className="text-muted">
                                                    <i className="fas fa-shield-alt me-1"></i>
                                                    Secure OAuth 2.0 authentication
                                                </small>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* What Happens Next */}
                        <Row className="justify-content-center mt-5">
                            <Col md={10}>
                                <Card className="bg-light border-0">
                                    <Card.Body>
                                        <h5 className="text-center mb-4">
                                            <i className="fas fa-question-circle me-2"></i>
                                            What happens next?
                                        </h5>
                                        <Row>
                                            <Col md={4} className="text-center mb-3">
                                                <div className="text-success mb-2">
                                                    <i className="fas fa-user-check fa-2x"></i>
                                                </div>
                                                <h6>1. Authorize</h6>
                                                <small className="text-muted">
                                                    You'll be redirected to Shopify to authorize the app
                                                </small>
                                            </Col>
                                            <Col md={4} className="text-center mb-3">
                                                <div className="text-success mb-2">
                                                    <i className="fas fa-cog fa-2x"></i>
                                                </div>
                                                <h6>2. Setup</h6>
                                                <small className="text-muted">
                                                    We'll automatically configure webhooks and permissions
                                                </small>
                                            </Col>
                                            <Col md={4} className="text-center mb-3">
                                                <div className="text-success mb-2">
                                                    <i className="fas fa-rocket fa-2x"></i>
                                                </div>
                                                <h6>3. Ready!</h6>
                                                <small className="text-muted">
                                                    Start syncing products and managing orders
                                                </small>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Back to Landing */}
                        <div className="text-center mt-4">
                            <Button variant="outline-secondary" href="/shopify">
                                <i className="fas fa-arrow-left me-2"></i>
                                Back to Landing Page
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ShopifyInstall;
